<template>
	<div>

		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Collections</span>
		</div>

		<div style="display: flex;overflow-x: scroll">
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 1 }" @click="changebtn(1)">Information
			</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 2 }" @click="changebtn(2)">Demands</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 3 }" @click="changebtn(3)">Product</div>
		</div>
		<div>
			<!-- 新闻收藏 -->
			<div style="display: flex;flex-direction: column;margin-top: 1rem;" v-if="activebtn == 1">

				<!-- 新闻pc -->
				<div class="news-left-box hover-up transition-normal" v-for="(item, index2) in data" :key="index2"
					@click="tonewsdetail(item.id)" v-if="!isMobile">
					<div class="news-left-box-img" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
					<div class="news-left-box-r">
						<div style="display: flex;flex-direction: column;flex: 1;">
							<div class="news-left-box-r-title text-hover">{{item.title}}</div>
							<div class="news-left-box-r-dec" v-show="item.subTitle">{{item.subTitle}}</div>
							<div class="news-left-box-r-tags">
								<div v-for="(tag, index3) in item.tags" :key="index3" style="margin-right: 0.5rem;"
									:style="{color: colorlist[index3]}">{{tag.name}} .</div>
							</div>
						</div>

						<div style="display: flex;align-items: center;margin-top: 0.5rem;">
							<!-- <img src="../../assets/imgs/news/icon-time.png" class="news-left-box-r-icon"> -->
							<span class="news-left-box-r-icontext">{{item.createdAt | format}}</span>
							<img src="../../assets/imgs/news/icon-eyes.png" class="news-left-box-r-icon">
							<span class="news-left-box-r-icontext">{{item.browseCount}}</span>
							<img :src="data.collected?require('../../assets/imgs/news/icon-star-light.png'):require('../../assets/imgs/news/icon-star.png')"
								class="news-left-box-r-icon">
							<span class="news-left-box-r-icontext">{{item.collectionCount}}</span>
							<img :src="data.liked?require('../../assets/imgs/news/icon-like-light.png'):require('../../assets/imgs/news/icon-like.png')"
								class="news-left-box-r-icon">
							<span class="news-left-box-r-icontext">{{item.likeCount}}</span>
							<!-- <span class="news-left-box-r-time">News | mar.29,2023</span> -->
						</div>
					</div>
				</div>


				<!-- 新闻mobile -->
				<ul class="list-post" style="margin-top: 1rem;" v-if="isMobile">
					<li class="mb-20 wow fadeInUp animated" :data-wow-delay="'0.'+atriclesindex*2"
						v-for="(item, atriclesindex) in data" @click="tonewsdetail(item.id)">
						<div class="d-flex bg-white has-border p-25 hover-up transition-normal border-radius-5"
							style="cursor: pointer;">
							<div class="post-content media-body">
								<h6 class="post-title mb-15 text-limit-2-row font-medium text-hover"
									style="font-size: 1rem;">{{item.title}}</h6>
								<div class="entry-meta meta-1 float-left font-x-small text-uppercase">
									<!-- <span class="post-on">{{item.createdAt|format}}</span> -->
									<span class="post-by">{{item.browseCount}} views</span>
								</div>
							</div>
							<div
								class="post-thumb post-thumb-80 d-flex ml-15 border-radius-5 img-hover-scale overflow-hidden">
								<span class="color-white">
									<!-- <img :src="hotData.items[0].coverImage" alt=""> -->
									<div :style="{backgroundImage: 'url('+item.coverImage+')'}" class="news-img-box">
									</div>
								</span>
							</div>
						</div>
					</li>
				</ul>

				<!-- 空状态 -->
				<div v-show="data.length==0&&!loading&&activebtn==1" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>

			<!-- 需求收藏 -->
			<div style="display: flex;flex-direction: column;margin-top: 1rem;" v-if="activebtn == 2">


				<div class="hover-up transition-normal fadeIn animated supplier-box"
					style="background-color: #fff;padding: 2rem;display: flex;margin-bottom: 2rem;border-radius: 1rem;"
					v-for="(item, index2) in demanddata" :key="index2">
					<div style="display: flex;flex-direction: column;width: 100%;position: relative;">
						<div style="display: flex;align-items: center;margin-bottom: 1rem;">
							<div :style="{backgroundImage: 'url('+item.user.avatar+')'}" style="" class="main-img">
							</div>
							<div style="" class="main-title" v-text="item.user.username"></div>
						</div>
						<!-- <div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
							<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
							display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;" v-text="c.name"></div>
						</div> -->
						<div @click="todemanddetail(item)" style="cursor: pointer;">

							<div style="font-size: 1rem;color: #000;margin-bottom: 1rem;" class="supplier-desc"
								v-text="item.content"></div>
							<!-- <div style="display: flex;justify-content: flex-end;margin-top: 1rem;" v-if="!isMobile">
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;position: absolute;right: 0;bottom: 0;"
										:class="{'btn-cyan':!item.follow, 'btn-lightgreen':item.follow}" @click="changefollow(item)" v-text="item.follow?'UnFollow':'Follow'"></div>
							</div> -->
							<div style="font-size: 0.8rem;color: #666;margin-bottom: 1rem;">
								# {{item.classify.title}}
							</div>

							<div style="display: flex;justify-content: space-between;align-items: center;">
								<div>
									Deadline: {{item.expireTime | formatDate}}
								</div>
								<div class="btn-cyan-liner"
									style="padding: 0.4rem 1rem;border-radius: 5rem;cursor: pointer;font-size: 0.8rem;font-weight: 500;">
									more
								</div>
							</div>
						</div>
					</div>
				</div>


				<!-- 空状态 -->
				<div v-show="demanddata.length==0&&!loading&&activebtn==2" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
			<div style="margin-top: 1rem;flex: 1;" :class="isMobile?'df jcsa fww':'row'" v-if="activebtn == 3">
				<template v-for="(item, index1) in products">
					<productItem :style="isMobile?'width: 48%;':null" :col="isMobile?'null':'col-4'" :item="item" :key="index1"></productItem>
					<productItem style="width: 48%;opacity: 0;" :col="null" :item="item"
						v-if="(products.length%2==1)&&isMobile">
					</productItem>
				</template>
				<!-- 空状态 -->
				<div v-show="products.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import productItem from '@/components/product/productItem.vue';
	export default {
		data() {
			return {
				type: 0,
				data: [],
				colorlist: ['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
				isMobile: false,
				loading: true,
				products:[],
				activebtn: 1,
				demanddata: []
			}
		},
		components: {
			productItem
		},
		filters: {
			formatDate: function(timestemp) {
				let date = new Date(timestemp * 1000)
				return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
			}
		},
		methods: {
			async getProduct() {
				let {
					data
				} = await this.$get('/gci/product/collections')
				this.products = data.items;
			},
			changebtn(type) {
				this.activebtn = type
				this.getdata()
			},
			getdata() {
				this.loading = true
				this.request({
					method: 'get',
					url: '/gci/user/article/list',
				}).then(res => {
					this.data = res.data.items
					this.loading = false
				}).catch(error => {
					console.error(error.response)
				})
			},
			tonewsdetail(id) {
				this.$router.push({
					name: 'newsdetail',
					query: {
						id: id
					}
				})
			},
			getdemanddata() {
				this.request({
					method: 'get',
					url: '/gci/demand/collection',
				}).then(res => {
					this.demanddata = res.data.items
				}).catch(error => {
					console.error(error.response)
				})
			},
			todemanddetail(item) {
				this.$router.push({
					name: 'demanddetail',
					query: {
						id: item.id
					}
				})
			},
		},
		mounted() {
			localStorage.getItem('isMobile') == 'null' ? this.isMobile = false : this.isMobile = true
			this.type = this.$route.query.type
			this.getdata()
			this.getdemanddata()
			this.getProduct()
		}
	}
</script>

<style lang="scss" scoped>
	li {
		list-style: none
	}

	.news-img-box {
		background-size: cover;
		background-repeat: no-repeat;
		background-position: top center;
		width: 5.625rem;
		height: 5rem;
		transition: transform .5s;
	}

	.news-img-box:hover {
		-webkit-transform: scale(1.1);
		-ms-transform: scale(1.1);
		transform: scale(1.1);
		-webkit-transition: -webkit-transform .5s;
		transition: -webkit-transform .5s;
		-o-transition: transform .5s;
		transition: transform .5s;
		transition: transform .5s, -webkit-transform .5s;
	}

	.r-title {
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;

		.r-title-bg {
			width: 13rem;
			position: absolute;
			left: -0.5rem;
			top: -2rem
		}
	}

	.avatar {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 50%;
	}

	.news-left-box {
		cursor: pointer;
		background: #FFFFFF;
		// box-shadow: 0px 4px 2.5rem -2px rgba(0,0,0,0.08);
		// border: 1px solid #E2E2E2;
		border-radius: 1rem;
		padding: 1rem;
		margin-bottom: 2rem;
		display: flex;
		align-items: center;

		&-img {
			min-width: 10rem;
			height: 10rem;
			border-radius: 0.1rem;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
		}

		&-r {
			display: flex;
			flex-direction: column;
			margin-left: 1rem;
			width: 34rem;
			height: 10rem;

			&-title {
				font-size: 1.2rem;
				font-weight: bold;
				color: #333;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			&-dec {
				font-size: 0.7rem;
				font-weight: 400;
				color: #666;
				margin-top: 0.5rem;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			&-tags {
				font-size: 0.7rem;
				margin-top: 0.5rem;
				display: flex;
			}

			&-icon {
				width: 1.2rem;
				height: 1.2rem;
				margin-right: 0.2rem;
			}

			&-icontext {
				font-size: 0.7rem;
				color: #666;
				margin-right: 1rem;
			}

			&-time {
				font-size: 0.7rem;
				color: #999;
				font-weight: 400;
			}
		}
	}

	.main-img {
		min-width: 2.5rem;
		height: 2.5rem;
		background-position: center center;
		background-size: cover;
		background-repeat: no-repeat;
		border-radius: 50%;
		margin-right: 1rem;
	}

	.main-title {
		color: #000;
		font-size: 1.2rem;
		font-weight: bold;
		margin-bottom: 0.5rem;
	}

	.supplier-desc {
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	@media (max-width:767px) {

		.main-img {
			// min-width: 100%;height: 10rem;margin-bottom: 1rem;margin-right: 0;
			margin-bottom: 1rem;
			margin-right: 1rem;
		}

		.main-title {
			font-size: 1.2rem;
		}

		.top-bg {
			margin-left: 5rem;
			width: calc(100vw - 5rem);
			height: 12rem;

			.search-box {
				display: none;
			}
		}

		.news-left {
			max-width: 100%;
		}

		.news-left-box-img {
			min-width: 6rem;
			height: 6rem !important;
		}

		.news-left-box-r-time {
			display: none;
		}

		.news-left-box {
			border: 1px solid #eee;
		}

		.col-3 {
			min-width: 100%;
			border: 1px solid #eee;
			margin-bottom: 1rem;
		}

		.news-left-box-r-dec {
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.news-left-box-r-title {

			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.news-left-box-r-tags {
			display: none;
		}
	}
</style>